import { render, staticRenderFns } from "./index.vue?vue&type=template&id=0fcaf1c8"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\华水\\hsmanagementsystem\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0fcaf1c8')) {
      api.createRecord('0fcaf1c8', component.options)
    } else {
      api.reload('0fcaf1c8', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=0fcaf1c8", function () {
      api.rerender('0fcaf1c8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/forms/index.vue"
export default component.exports